import { useParams } from "react-router-dom"

export const useRouteId = (): string => {
	const params = useParams<{ id?: string }>()
	if (!params.id) {
		throw new Error("useRouteId: 'id' parameter is not present in the URL.")
	}
	return params.id
}
